import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { BaseUiModule } from '@mitsubishi/shared/ui';

@Component({
  selector: 'apm-page-not-found',
  imports: [CommonModule, BaseUiModule, RouterLink],
  templateUrl: './page-not-found.component.html',
})
export class PageNotFoundComponent {}
